import fetch from './fetch'

class LawsuitApi {
	public addTask(form: any) {
		return fetch({
			url: 'injury/order/lawsuit/add',
			method: 'post',
			data: form,
			timeout: 60 * 1000,
		})
	}

	public queryRelated(orderNo: any) {
		return fetch({
			url: 'injury/order/lawsuit/queryRelated',
			method: 'post',
			params: {
				orderNo,
			},
		})
	}

	public getList(form: any) {
		return fetch({
			url: 'injury/tasklist/lawsuit/list',
			method: 'post',
			data: form,
		})
	}

	public exportList(form: any) {
		return fetch({
			url: 'injury/tasklist/lawsuit/export',
			method: 'post',
			data: form,
			timeout: 0,
			responseType: 'blob',
		})
	}

	public getLawsuitTaskDetail(orderId: string) {
		return fetch({
			url: 'injury/order/lawsuit/detail',
			method: 'GET',
			params: {
				orderId,
			},
		})
	}

	public getLawyerList(form: any) {
		return fetch({
			url: 'injury/order/lawsuit/canSelectLawyer',
			method: 'POST',
			data: {
				...form,
			},
		})
	}

	public getPlanList(orderId: string) {
		return fetch({
			url: 'injury/order/lawsuit/schemes',
			method: 'GET',
			params: {
				orderId,
			},
		})
	}

	public savePlanList(form: any) {
		return fetch({
			url: 'injury/order/scheme/save',
			method: 'POST',
			data: {
				...form,
			},
		})
	}

	public getDisability(arg: string) {
		return fetch({
			url: 'bigdata/universal/disability',
			method: 'POST',
			data: {
				arg,
			},
		})
	}

	public getCourt(form: any) {
		return fetch({
			url: 'bigdata/universal/court',
			method: 'POST',
			data: {
				...form,
			},
		})
	}

	public selectLawyer(orderId: string, thirdId: string) {
		return fetch({
			url: 'injury/order/lawsuit/selectLawyer',
			method: 'GET',
			params: {
				orderId,
				thirdId,
			},
		})
	}

	public updateMedia(form: any) {
		return fetch({
			url: 'injury/order/lawsuit/updateMedia',
			method: 'POST',
			data: {
				...form,
			},
		})
	}

	public cancelLawsuit(form: any) {
		return fetch({
			url: 'injury/order/lawsuit/cancel',
			method: 'POST',
			data: {
				...form,
			},
		})
	}

	public exportOrder(orderId: string) {
		return fetch({
			url: 'injury/order/exportLawsuitOrder',
			method: 'POST',
			params: {
				orderId,
			},
			responseType: 'blob',
		})
	}

	public exportLawsuitOrderMedia(orderId: string) {
		return fetch({
			url: 'injury/order/exportLawsuitOrderMedia',
			method: 'POST',
			params: {
				orderId,
			},
			responseType: 'blob',
		})
	}

	public lawsuitAudit(form: any) {
		return fetch({
			url: 'injury/task/auditLawsuitTask',
			method: 'POST',
			data: {
				...form,
			},
		})
	}
}

export default new LawsuitApi()
